var to = function to2(promise) {
  return promise.then(function(data) {
    return [null, data];
  })["catch"](function(err) {
    return [err];
  });
};
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
var throttle = function throttle2(fn) {
  var time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
  var timer = null;
  return function() {
    if (timer === null) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      fn.apply(this, args);
      timer = setTimeout(function() {
        timer = null;
      }, time);
    }
  };
};
var once = function once2(fn) {
  var result;
  var func = fn;
  return function() {
    if (func) {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      result = func.apply(this, args);
      func = null;
    }
    return result;
  };
};
var sleep = function sleep2(time) {
  return new Promise(function(resolve) {
    return setTimeout(resolve, time);
  });
};
var deepcopy = function deepcopy2(obj) {
  var cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var find = function find2(list, f) {
    return list.filter(f)[0];
  };
  if (obj === null || _typeof(obj) !== "object") {
    return obj;
  }
  var hit = find(cache, function(c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }
  var copy = Array.isArray(obj) ? [] : {};
  cache.push({
    original: obj,
    copy
  });
  Object.keys(obj).forEach(function(key) {
    copy[key] = deepcopy2(obj[key], cache);
  });
  return copy;
};
var loadScript = function loadScript2(url, success) {
  var _window$document$getE = window.document.getElementsByTagName("script"), _window$document$getE2 = _slicedToArray(_window$document$getE, 1), firstScript = _window$document$getE2[0];
  var script = window.document.createElement("script");
  script.src = url;
  script.type = "text/javascript";
  script.async = false;
  firstScript.parentNode.insertBefore(script, firstScript);
  if (typeof success === "function") {
    script.onload = success;
  }
  return script;
};
var versionCompare = function versionCompare2() {
  var preVersion = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var lastVersion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var preList = preVersion.split(".");
  var lastList = lastVersion.split(".");
  var maxL = Math.max(preList.length, lastList.length);
  var result = 0;
  for (var i = 0; i < maxL; i++) {
    var preValue = preList.length > i ? preList[i] : 0;
    var preNum = isNaN(Number(preValue)) ? preValue.charCodeAt() : Number(preValue);
    var lastValue = lastList.length > i ? lastList[i] : 0;
    var lastNum = isNaN(Number(lastValue)) ? lastValue.charCodeAt() : Number(lastValue);
    if (preNum < lastNum) {
      result = -1;
      break;
    } else if (preNum > lastNum) {
      result = 1;
      break;
    }
  }
  return result;
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var isArray = function isArray2(arr) {
  return Array.isArray(arr);
};
var isBoolean = function isBoolean2(val) {
  return typeof val === "boolean";
};
var isString = function isString2(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
};
var isObject = function isObject2(obj) {
  return Object.prototype.toString.call(obj) === "[object Object]";
};
var isHtmlElement = function isHtmlElement2(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
};
var isFunction = function isFunction2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
};
var isUndefined = function isUndefined2(val) {
  return val === void 0;
};
var isDefined = function isDefined2(val) {
  return val !== void 0 && val !== null;
};
var isTruthy = function isTruthy2(val) {
  return val && val !== void 0 && val !== null && val !== "";
};
var isNull = function isNull2(value) {
  return value === null;
};
var isEmptyObject = function isEmptyObject2(obj) {
  if (!obj || _typeof(obj) !== "object" || Array.isArray(obj)) {
    return false;
  }
  return !Object.keys(obj).length;
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var jsonToUrl = function jsonToUrl2() {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var keys = Object.keys(obj);
  return keys.map(function(key) {
    return "".concat(key, "=").concat(obj[key]);
  }).join("&");
};
var encodeURIJson = function encodeURIJson2() {
  var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var split = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
  var pairs = [];
  var keys = Object.keys(obj);
  keys.forEach(function(key) {
    var value = obj[key];
    if (["", void 0, null].includes(value)) {
      return;
    }
    if (isArray(value)) {
      for (var i = 0; i < value.length; ++i) {
        pairs.push("".concat(encodeURIComponent("".concat(key, "[").concat(i, "]")), "=").concat(encodeURIComponent(value[i])));
      }
      return;
    }
    pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(obj[key])));
  });
  return pairs.join(split);
};
var setUrlParams = function setUrlParams2() {
  var originUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href;
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var url = originUrl;
  var params = opts;
  if (isObject(url)) {
    params = _objectSpread({}, url);
    url = window.location.href;
  }
  var paramsKeys = Object.keys(params);
  var urlJson = urlToJson(url);
  paramsKeys.forEach(function(key) {
    if (params[key] === "") {
      delete urlJson[key];
    } else {
      urlJson[key] = params[key];
    }
  });
  var _url$split = url.split("?"), _url$split2 = _slicedToArray(_url$split, 1), rel = _url$split2[0];
  if (Object.keys(urlJson).length !== 0) {
    rel = "".concat(rel, "?").concat(jsonToUrl(urlJson));
  }
  return rel;
};
var strToJson = function strToJson2(str) {
  var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&";
  if (!str) {
    return {};
  }
  var dataObj = {};
  var strArr = str.split(key);
  for (var i = 0, len = strArr.length; i < len; i++) {
    var paramArr = strArr[i].split("=");
    var _paramArr = _slicedToArray(paramArr, 2), _key = _paramArr[0], val = _paramArr[1];
    dataObj[_key] = val;
  }
  return dataObj;
};
var urlToJson = function urlToJson2() {
  var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href;
  var urlObject = {};
  var index = url.indexOf("?");
  if (index === -1) {
    return urlObject;
  }
  var urlString = url.substring(index + 1);
  var urlArray = urlString.split("&");
  for (var i = 0, len = urlArray.length; i < len; i++) {
    var urlItem = urlArray[i];
    var item = urlItem.split("=");
    var _item = _slicedToArray(item, 2), key = _item[0], value = _item[1];
    urlObject[key] = value;
  }
  return urlObject;
};
var convertProtocol = function convertProtocol2() {
  var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var proto = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : window.location.protocol;
  var protocol = proto.replace(":", "");
  return url.replace(/^(http:|https:)/i, "".concat(protocol, ":"));
};
var EventHub = {
  mix: function mix(d, src, m) {
    var des = d;
    var map = m;
    if (_typeof(des) !== "object") {
      return des;
    }
    map = map || function(d2, s, i) {
      if (!(des[i] || i in des)) {
        return s;
      }
      return d2;
    };
    if (map === true) {
      map = function map2(d2, s) {
        return s;
      };
    }
    var keys = Object.keys(src);
    keys.forEach(function(i) {
      des[i] = map(des[i], src[i], i);
      if (des[i] === void 0) {
        delete des[i];
      }
    });
    return des;
  },
  createEvents: function createEvents(obj) {
    var events = {};
    EventHub.mix(obj, {
      on: function on(evtType, handler) {
        events[evtType] = events[evtType] || [];
        events[evtType].push(handler);
        return obj;
      },
      fire: function fire(evtType) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var args = opts;
        EventHub.mix(args, {
          type: evtType,
          target: obj,
          preventDefault: function preventDefault() {
            args.returnValue = false;
          }
        });
        var handlers = events[evtType] || [];
        handlers.forEach(function(handler) {
          handler(args);
        });
        return args.returnValue !== false;
      }
    });
    return obj;
  }
};
EventHub.events = EventHub.events || {};
var cookie = {
  set: function set(name, val) {
    var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var options = opts;
    var value = val;
    if (value === null) {
      value = "";
      options.expires = -1;
    }
    var expires = "";
    if (options.expires && (typeof options.expires === "number" || options.expires.toUTCString)) {
      var date;
      if (typeof options.expires === "number") {
        date = new Date();
        date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1e3);
      } else {
        date = options.expires;
      }
      expires = "; expires=".concat(date.toUTCString());
    }
    options.path = options.path || "/";
    options.domain = options.domain || location.hostname;
    var path = "; path=".concat(options.path);
    var domain = "; domain=".concat(options.domain);
    var secure = options.secure ? "; secure" : "";
    document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("");
  },
  get: function get(name) {
    var cookies = document.cookie ? document.cookie.split("; ") : [];
    var len = cookies.length;
    var ret = name ? "" : Object.create(null);
    for (var i = 0; i < len; i++) {
      var _cookies$i$split = cookies[i].split("="), _cookies$i$split2 = _slicedToArray(_cookies$i$split, 2), key = _cookies$i$split2[0], value = _cookies$i$split2[1];
      if (key === name) {
        ret = value;
        break;
      }
      if (!name) {
        ret[key] = value;
      }
    }
    return ret;
  },
  del: function del(val, options) {
    var _this = this;
    if (isArray(val)) {
      val.forEach(function(item) {
        _this.set(item, null, options);
      });
    } else {
      this.set(val, null, options);
    }
  }
};
var LS = {
  age: 1 * 30 * 24 * 60 * 60 * 1e3,
  setAge: function setAge(age) {
    this.age = age;
    if (this.key) {
      this.set(this.key, this.value);
    }
    return this;
  },
  set: function set2(key, value) {
    var isObject3 = value instanceof Object;
    var time = new Date().getTime();
    var age = time + this.age;
    var storage = {
      time,
      age,
      isObject: isObject3
    };
    this.key = key;
    this.value = value;
    localStorage.removeItem(key);
    storage.value = value;
    localStorage.setItem(key, JSON.stringify(storage));
    return this;
  },
  isExpire: function isExpire(key) {
    var isExpire2 = true;
    var value = localStorage.getItem(key);
    var now = new Date().getTime();
    if (value) {
      var storage = JSON.parse(value);
      isExpire2 = now > storage.age;
    }
    return isExpire2;
  },
  get: function get2(key) {
    var isExpire2 = this.isExpire(key);
    if (isExpire2) {
      localStorage.removeItem(key);
      return null;
    }
    var value = localStorage.getItem(key);
    var storage = JSON.parse(value);
    return storage.value;
  }
};
var device = {
  ua: function ua() {
    return window.navigator.userAgent.toLowerCase();
  },
  isIphone: function isIphone() {
    return /iphone/.test(this.ua());
  },
  isHuawei: function isHuawei() {
    return /huawei/.test(this.ua());
  },
  isHonor: function isHonor() {
    return /honor/.test(this.ua());
  },
  isOppo: function isOppo() {
    return /oppo/.test(this.ua());
  },
  isOppoR15: function isOppoR15() {
    return /pacm00/.test(this.ua());
  },
  isVivo: function isVivo() {
    return /vivo/.test(this.ua());
  },
  isXiaomi: function isXiaomi() {
    return /mi\s/.test(this.ua());
  },
  isXiaomi2s: function isXiaomi2s() {
    return /mix\s/.test(this.ua());
  },
  isRedmi: function isRedmi() {
    return /redmi/.test(this.ua());
  },
  isSamsung: function isSamsung() {
    return /sm-/.test(this.ua());
  }
};
export { EventHub, convertProtocol, cookie, deepcopy, device, encodeURIJson, isArray, isBoolean, isDefined, isEmptyObject, isFunction, isHtmlElement, isNull, isObject, isString, isTruthy, isUndefined, jsonToUrl, loadScript, once, setUrlParams, sleep, LS as storage, strToJson, throttle, to, urlToJson, versionCompare };
